module.exports = __webpack_public_path__ + "static/img/874044a20cd0260a6db74fb0eeb7b2fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon2.jpg
// module id = Tnw5
// module chunks = 1